import './App.css';
import React from 'react';
import Navbar from './components/Navbar';
import Gallery from './components/Gallery';
import Footer from './components/Footer';
import PrefooterCard from './components/PrefooterCard';
import WhatsAppFloat from './components/WhatsAppFloat';

function App() {
  const [active, setActive] = React.useState('cocina');
  const [showContent, setShowContent] = React.useState(false);

  React.useEffect(() => {
    // Bloquear scroll cuando está en la pantalla de bienvenida
    if (!showContent) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [showContent]);

  React.useEffect(() => {
    if (!showContent) return;
    
    const sectionIds = ['cocina', 'mesadas', 'mesadas-madera', 'mesadas-acero', 'mesadas-premium', 'combos', 'muebles'];
    const sections = sectionIds
      .map(id => document.getElementById(id))
      .filter(Boolean);
    if (sections.length === 0) return;

    const observer = new IntersectionObserver((entries) => {
      const visible = entries
        .filter(e => e.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
      if (visible && visible.target && visible.target.id) {
        setActive(visible.target.id);
      }
    }, { rootMargin: '-40% 0px -50% 0px', threshold: [0.1, 0.25, 0.5, 0.75] });

    sections.forEach(sec => observer.observe(sec));
    return () => observer.disconnect();
  }, [showContent]);

  const handleContinue = () => {
    setShowContent(true);
    // Scroll suave al inicio después de un pequeño delay para que se renderice el contenido
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 100);
  };

  return (
    <div className="tm-app">
      <div className="tm-topbar">
        <div className="tm-container">
          <div className="tm-marquee" aria-live="polite">
            <span>¡Veni a ver tu mueble a nuestro deposito en Merlo!</span>
          </div>
        </div>
      </div>
      <div className="tm-sticky">
        <div className="tm-brandbar">
          <div className="tm-container tm-brandbar-inner">
            <span className="tm-brandbar-logo">JV@</span>
            <span className="tm-brandbar-sub">tienda</span>
          </div>
        </div>
        {showContent && <Navbar active={active} />}
      </div>
      {!showContent ? (
        <div className="tm-welcome-screen">
          <section className="tm-hero tm-hero-fullscreen">
            <div
              className="tm-hero-box"
              style={{
                backgroundImage: "url('/assets/img/logo/logo.PNG')"
              }}
            >
              <div className="tm-hero-card">
                <h1>Bienvenidos a JV@</h1>
                <p>Descubre nuestra amplia selección de muebles de calidad para transformar tu hogar</p>
              </div>
            </div>
            <button className="tm-continue-btn" onClick={handleContinue}>
              Continuar con la tienda
            </button>
          </section>
        </div>
      ) : (
        <>
          <main className="tm-main">
            <section className="tm-hero">
              <div
                className="tm-hero-box"
                style={{
                  backgroundImage: "url('/assets/img/logo/logo.PNG')"
                }}
              >
                <div className="tm-hero-card">
                  <h1>Bienvenidos a JV@</h1>
                  <p>Descubre nuestra amplia selección de muebles de calidad para transformar tu hogar</p>
                </div>
              </div>
            </section>

        <section id="cocina" className="tm-section tm-gray">
          <div className="tm-container">
            <h2>Cocina</h2>
            <h3 className="tm-subtitle">Modulares</h3>
            <Gallery category="cocina-modulares" />

            <h3 className="tm-subtitle">Barras completas rectas</h3>
            <Gallery category="cocina-barras-completas-rectas" />

            <h3 className="tm-subtitle">Bajo barras</h3>
            <Gallery category="cocina-bajo-barras" />

            <h3 className="tm-subtitle">Alzada de barra</h3>
            <Gallery category="cocina-alzada-de-barra" />

            <h3 className="tm-subtitle">Portamicroondas</h3>
            <Gallery category="cocina-portamicroondas" />

            <h3 className="tm-subtitle">Desayunadores y banquetas</h3>
            <Gallery category="cocina-desayunadores-y-banquetas" />

            <h3 className="tm-subtitle">Despenseros</h3>
            <Gallery category="cocina-despenseros" />

            <h3 className="tm-subtitle">Despenseros cristaleros (no incluye vidrios)</h3>
            <Gallery category="cocina-despenseros-cristaleros" />
          </div>
        </section>

        <section id="mesadas" className="tm-section tm-white">
          <div className="tm-container">
            <h2>Mesadas de marmolina</h2>

            <h3 className="tm-subtitle">Alacena + bajo mesada + bacha simple con mesada + griferia monocomando </h3>
            <Gallery category="mesadas-bacha-simple-mesada-griferia" />

            <h3 className="tm-subtitle">Alacena + bajo mesada + bacha doble con mesada + griferia monocomando</h3>
            <Gallery category="mesadas-bacha-doble-mesada-griferia" />

            <h3 className="tm-subtitle">Bajo mesada + bacha doble con mesada + griferia monocomando</h3>
            <Gallery category="mesadas-bajo-mesada-mesada-doble-griferia" />

            <h3 className="tm-subtitle">Bacha simple con mesada o mesada sin bacha</h3>
            <Gallery category="mesadas-bacha-simple-o-sin-bacha" />

            <h3 className="tm-subtitle">Bacha doble con mesada</h3>
            <Gallery category="mesadas-bacha-doble-mesada" />
          </div>
        </section>

        <section id="mesadas-madera" className="tm-section tm-gray">
          <div className="tm-container">
            <h2>Mesadas de madera</h2>

            <h3 className="tm-subtitle">Alacena + bajo mesada + bacha simple con mesada + griferia monocomando</h3>
            <Gallery category="mesadas-madera-alacena-bajo-mesada-bacha-simple" />

            <h3 className="tm-subtitle">Alacena + bajo mesada + bacha doble con mesada + griferia monocomando</h3>
            <Gallery category="mesadas-madera-alacena-bajo-mesada-bacha-doble" />

            <h3 className="tm-subtitle">Bajo mesada + bacha simple con mesada + griferia monocomando</h3>
            <Gallery category="mesadas-madera-bajo-mesada-bacha-simple" />

            <h3 className="tm-subtitle">Bajo mesada + bacha doble con mesada + griferia monocomando</h3>
            <Gallery category="mesadas-madera-bajo-mesada-bacha-doble" />

            <h3 className="tm-subtitle">Bacha simple con mesada</h3>
            <Gallery category="mesadas-madera-bacha-simple" />

            <h3 className="tm-subtitle">Bacha doble con mesada</h3>
            <Gallery category="mesadas-madera-bacha-doble" />
          </div>
        </section>

        <section id="mesadas-acero" className="tm-section tm-white">
          <div className="tm-container">
            <h2>Mesadas de acero</h2>

            <h3 className="tm-subtitle">Alacena + bajo mesada + bacha simple con mesada + griferia monocomando</h3>
            <Gallery category="muebles-alacena-bajo-mesada-bacha-simple" />

            <h3 className="tm-subtitle">Bajo mesada + bacha simple con mesada + griferia monocomando</h3>
            <Gallery category="muebles-bajo-mesada-bacha-simple" />

            <h3 className="tm-subtitle">Bajo mesada + bacha simple con mesada + griferia monocomando</h3>
            <Gallery category="muebles-bajo-mesada-bacha-simple-mesada" />
          </div>
        </section>

        <section id="mesadas-premium" className="tm-section tm-gray">
          <div className="tm-container">
            <h2>Mesadas premium</h2>
            <Gallery category="mesadas-premium" />
          </div>
        </section>

            <section id="combos" className="tm-section tm-white">
              <div className="tm-container">
                <h2>Combos</h2>

                <h3 className="tm-subtitle">Alacena + Bajo mesada</h3>
                <Gallery category="combos-alacena-bajo-mesada" />

                <h3 className="tm-subtitle">Tapa de madera</h3>
                <Gallery category="combos-tapa-madera" />
              </div>
            </section>

        <section id="muebles" className="tm-section tm-gray">
          <div className="tm-container">
            <h2>Muebles</h2>

            <h3 className="tm-subtitle">Bajo solo</h3>
            <Gallery category="muebles-bajo-solo" />

            <h3 className="tm-subtitle">Bajo con tapa de madera</h3>
            <Gallery category="muebles-bajo-tapa-madera" />
          </div>
        </section>
          </main>
          <section className="tm-prefooter">
            <div className="tm-container tm-prefooter-grid">
              <PrefooterCard />
              <div className="tm-prefooter-social">
                <div className="tm-pf-title">Seguinos:</div>
                <div className="tm-pf-icons">
                  <a className="tm-pf-circle" href="https://www.facebook.com/vanesa.pereyra.129" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                      <path d="M22.675 0h-21.35C.595 0 0 .594 0 1.326v21.348C0 23.406.595 24 1.325 24h11.494v-9.294H9.691V11.01h3.128V8.414c0-3.1 1.893-4.788 4.659-4.788 1.325 0 2.463.099 2.795.143v3.24l-1.918.001c-1.504 0-1.796.715-1.796 1.764v2.314h3.587l-.467 3.696h-3.12V24h6.116C23.406 24 24 23.406 24 22.674V1.326C24 .594 23.406 0 22.675 0z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>
          </section>
          <Footer />
          <WhatsAppFloat />
        </>
      )}
    </div>
  );
}

export default App;
